module.exports = __webpack_public_path__ + "img/back-to-top.8777a7eb.svg";